// eslint-disable-next-line camelcase
__webpack_public_path__ = window.CartSave

